import { render, staticRenderFns } from "./page-head-avatar.vue?vue&type=template&id=17542170"
import script from "./page-head-avatar.vue?vue&type=script&lang=ts"
export * from "./page-head-avatar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17542170')) {
      api.createRecord('17542170', component.options)
    } else {
      api.reload('17542170', component.options)
    }
    module.hot.accept("./page-head-avatar.vue?vue&type=template&id=17542170", function () {
      api.rerender('17542170', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/page-head-avatar.vue"
export default component.exports